import React from 'react';
import IncomingShipmentItemPhotoCell from './IncomingShipmentItemPhotoCell';
import IncomingShipmentQuantityField from './IncomingShipmentQuantityField';
import IncomingScanStatusBadge from './IncomingScanStatusBadge';
import { scannedItemStatusBadgeClass, scannedItemStatusLabel } from './incomingShipmentScannedStatusUi';

const IncomingShipmentScanCard = ({
  item,
  bindItemId,
  bindSearch,
  setBindSearch,
  bindSearchResults,
  bindSearchLoading,
  bindSubmitting,
  openBindDropdown,
  bindProductToItem,
  itemPhotoUploadingId,
  uploadItemPhoto,
  deleteItemPhoto,
  deleteScannedItem,
  saveItemQuantity,
  itemDeletingId,
  itemQuantitySavingId
}) => {
  const unresolved = !item.foundInCatalog || !item.productCode;

  return (
    <div
      className='mb-2'
      style={{
        background: unresolved ? '#fff5f5' : '#fff',
        borderRadius: '12px',
        border: '1px solid #e9ecef',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        padding: '12px'
      }}
    >
      <div className='d-flex justify-content-between align-items-start mb-1'>
        <div className='font-weight-bold text-monospace' style={{ fontSize: '1.03rem', lineHeight: 1.2 }}>
          {item.barcode}
        </div>
        <IncomingScanStatusBadge item={item} />
      </div>

      <div className='small mb-1'>
        <span className={scannedItemStatusBadgeClass(item.scanStatus)} title={item.scanStatus || ''}>
          {scannedItemStatusLabel(item.scanStatus)}
        </span>
      </div>

      {item.productCode ? (
        <div className='small text-monospace text-muted mb-1'>Артикул: {item.productCode}</div>
      ) : null}
      {item.foundInCatalog ? (
        <div className='small text-muted mb-1'>{item.name || ''}</div>
      ) : null}
      <div
        className='d-flex align-items-center flex-wrap mb-2'
        style={{ gap: '0.5rem' }}
        data-incoming-item-action='true'
      >
        <span className='small'>Кількість:</span>
        <IncomingShipmentQuantityField
          itemId={item.id}
          quantity={item.quantity}
          saving={itemQuantitySavingId === item.id || itemDeletingId === item.id}
          onSave={(q) => saveItemQuantity(item.id, q)}
        />
        <button
          type='button'
          className='btn btn-sm btn-outline-danger ml-auto'
          title='Видалити позицію'
          onClick={() => deleteScannedItem(item.id)}
          disabled={itemDeletingId === item.id || bindSubmitting || itemQuantitySavingId === item.id}
        >
          <i className='bi bi-trash' aria-hidden />
        </button>
      </div>

      <div className='d-flex align-items-center mb-1' style={{ gap: '0.5rem' }}>
        {!item.foundInCatalog ? (
          <button
            type='button'
            className='btn btn-dark btn-sm'
            style={{ minHeight: '36px' }}
            onClick={() => openBindDropdown(item.id)}
            disabled={bindSubmitting}
            data-bind-open-btn='true'
          >
            Привʼязати
          </button>
        ) : null}
      <IncomingShipmentItemPhotoCell
          item={item}
          placement='withBind'
          uploading={itemPhotoUploadingId === item.id}
          onSelectFile={(file) => uploadItemPhoto(item.id, file)}
          onDelete={() => deleteItemPhoto(item.id)}
        />
      </div>

      {!item.foundInCatalog && bindItemId === item.id ? (
        <div className='border rounded p-2 mt-2 bg-light'>
          <input
            type='text'
            className='form-control form-control-sm'
            placeholder='Пошук товару'
            value={bindSearch}
            onChange={(e) => setBindSearch(e.target.value)}
            disabled={bindSubmitting}
            data-bind-search-input='true'
          />
          <div className='mt-2'>
            {bindSearchLoading ? <div className='small text-muted'>Пошук...</div> : null}
            {!bindSearchLoading && (bindSearchResults || []).slice(0, 8).map((p) => (
              <button
                key={p.id}
                type='button'
                className='dropdown-item px-2 py-1'
                onClick={() => bindProductToItem(p.id)}
                disabled={bindSubmitting}
              >
                <span className='font-weight-bold'>{p.code || p.productCode || `#${p.id}`}</span>
                {' — '}
                <span>{p.name}</span>
              </button>
            ))}
            {!bindSearchLoading && bindSearch.trim().length >= 2 && !(bindSearchResults || []).length ? (
              <div className='small text-muted'>Нічого не знайдено</div>
            ) : null}
          </div>
        </div>
      ) : null}

      <div className='text-muted small mt-2'>{item.scannedAt || '-'}</div>
    </div>
  );
};

export default IncomingShipmentScanCard;
